<template>
  <transition name="slide-down" mode="out-in">
    <div class="flex justify-center items-center h-screen">
      <div class="flex-col w-1/4 mb-4">
        <TextInput
          id="input"
          class="mb-4"
          placeholder="Enter Totp"
          v-model="inputText"
          :max-length="6"
          @enter="submit"/>
        <Button
          type="primary"
          :inFlight="isSubmitting"
          class="text-gray-300 mx-auto"
          @onClick="submit"
        >
          Continue
        </Button>
        <div v-if="errorMessage" class="mt-8">
          <ErrorMessage :error="errorMessage" />
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
import TextInput from '@/components/TextInput.vue';
import Button from '@/components/Button.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { mapActions } from 'vuex';

export default {
  name: 'TotpVerify',
  components: { Button, ErrorMessage, TextInput },
  async mounted() {
    const input = document.getElementById('input');
    input.focus();
    const { data } = await this.totpRecoveryTokens();
    this.recoveryTokens = data.recoveryTokens;
  },
  data() {
    return {
      inputText: '',
      recoveryTokens: [],
      errorMessage: '',
      isSubmitting: false,
    };
  },
  methods: {
    ...mapActions(['verifyTotp', 'totpRecoveryTokens']),
    async submit() {
      this.errorMessage = '';
      this.isSubmitting = true;
      try {
        const status = await this.verifyTotp({ token: this.inputText });
        if (status === 'inactive') {
          await this.$router.push('/inactive-organization');
        } else if (status !== 'expired' && status !== 'anonymous') {
          await this.$router.push('/report');
        }
      } catch (e) {
        const responseData = e && e.response && e.response.data;
        this.errorMessage = (responseData && (responseData.error || responseData.detail))
          || 'The code you entered is incorrect. Please try again.';
        this.inputText = '';
        this.$nextTick(() => document.getElementById('input').focus());
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped></style>
